import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'SelectAllInverseFilterItemsToggle',
  props: {
    itemsCount: null,
    selectedCount: null
  },
  setup(__props: any) {

const props = __props as {
  itemsCount?: number
  selectedCount?: number
}



const selectedCounter = computed(() => {
  if (props.itemsCount && props.selectedCount) {
    return `${props.selectedCount} / ${props.itemsCount}`
  }

  if (!props.itemsCount && props.selectedCount) {
    return props.selectedCount
  }
})

const chipColor = computed(() => {
  if (props.itemsCount === props.selectedCount) {
    return 'var(--color-silver)'
  } else {
    return 'var(--color-blue--lighter)'
  }
})

return { __sfc: true,props, selectedCounter, chipColor }
}

})